import { SpriteAssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { VSOption } from "servertypes/SharedTypes";
import { getRectTexture } from "utils/Misc";
import { Container } from "pixi.js";

export class DarkenOverlay extends View {
    private dragonsContainer: Container;
    private pandasContainer: Container;

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {factory, layout, resources} = this.services;
        const spec = resources.getSpec(`darkenoverlay`);
        factory.applySpec(this, spec);

        this.dragonsContainer = factory.createContainer({visible: false, alpha: spec.overlayAlpha}, this);
        this.pandasContainer = factory.createContainer({visible: false, alpha: spec.overlayAlpha}, this);

        const texture = getRectTexture(services, 1, 1, spec.overlayColour, 1);

        for (const child of Object.values(spec.dragons)) {
            factory.createSpriteFromTexture(texture, {...child as SpriteAssetSpec, scale: 160}, this.dragonsContainer);
        }

        for (const child of Object.values(spec.pandas)) {
            factory.createSpriteFromTexture(texture, {...child as SpriteAssetSpec, scale: 160}, this.pandasContainer);
        }

        this.resize();
        layout.onResize.add(() => this.resize());
    }

    enable(vsPickIndex?: VSOption): void {

        if (vsPickIndex === undefined) {
            this.dragonsContainer.visible = true;
            this.pandasContainer.visible = true;

            this.resize();

            return;
        }

        if (vsPickIndex === VSOption.DRAGON) {
            this.dragonsContainer.visible = false;
            this.pandasContainer.visible = true;

        } else {
            this.dragonsContainer.visible = true;
            this.pandasContainer.visible = false;
        }

        this.resize();
    }

    disable(): void {

        this.dragonsContainer.visible = false;
        this.pandasContainer.visible = false;
    }

    private resize(): void {

        const bounds = this.services.layout.getScreenBoundaryInBucketSpace();

        if (bounds.width > bounds.height) {
            this.width = bounds.width;
            this.scale.y = this.scale.x;

        } else {
            this.height = bounds.height;
            this.scale.x = this.scale.y;
        }
    }
}